<div class="main_content">
  <app-breadcrumb></app-breadcrumb>
  <div #page_section class="page_main_sec">
    <div class="OpenSearch_main_sec">
      <!-- title bar section Start-->
      <div class="container-fluid">
        <!-- <div class="post-nav-wrap">
            <div class="title-wrap">
              <p class="title">Open Search</p>
            </div>
            <ul class="nav top-actions">
              <li>
                <a [routerLink]="['/home']">
                  <i class="material-icons theme-text-color">home</i>
                </a>
              </li>
            </ul>
          </div> -->
      </div>
      <!-- title bar section  End-->
    </div>

    <!-- advance Search section Start-->
    <div class="tab-content">
      <div>
        <!-- Table View -->
        <div class="table_card_sec mb_0">
          <div class="table scroll_table">
            <div class="row advance-search-wrp">
              <!--<div class="bx-sub-title mb-3">Filter Option</div>-->
              <div class="col-lg-3">

                <!-- <app-dropdown-multiselect #ddlDocselect [lstDropdownOption]="docTypeList" [labelText]="'Work Item Type'"
                    [allSelected]="true">
                  </app-dropdown-multiselect> -->

                <mat-form-field appearance="legacy" [style.width.%]="100">
                  <mat-label for="feedback_category">Feedback Category<span
                      class="comment_mandatory_changeDocumentType">*</span></mat-label>
                  <mat-select [(ngModel)]="selectedFeedBackcategor" id="feedback_category">
                    <mat-option [value]="option.value" *ngFor="let option of docTypeList">
                      {{ option.text }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-lg-3">
                <mat-form-field appearance="legacy" [style.width.%]="100">
                  <mat-label for="title">
                    Title <span class="comment_mandatory_changeDocumentType">*</span>
                  </mat-label>
                  <input matInput placeholder="Title" [(ngModel)]="selectfeedbackTitle" id="title">
                </mat-form-field>
              </div>
              <div class="col-lg-3">
                <mat-label>Feedback Type<span class="comment_mandatory_changeDocumentType">*</span></mat-label>
                <br />
                <mat-radio-group aria-label="Select an option" [(ngModel)]="selectFeedbackType">
                  <mat-radio-button value="Feedback">Feedback</mat-radio-button>
                  <mat-radio-button value="Suggestion">Suggestion</mat-radio-button>
                </mat-radio-group>

              </div>
              <div class="col-lg-6 col-sm-6 cmnt_box_main">
                <div class="cmnt_textarea_sec" [ngClass]="isCommentExpand?'expanded_textarea':''">
                  <span class="textarea_font_sec" title="Show list of restricted keywords"
                    (click)="showModal(restrictedKeywordModal,'sm')">
                    <img src="../../../assets/img/transaction/info.png" alt="Info">
                  </span>
                  <span class="expand_textarea_sec" (click)="isCommentExpand = !isCommentExpand">
                    <img src="../../../assets/img/transaction/expand.png" alt="" title="Expand">
                  </span>
                  <span class="textarea_editor_main_sec">
                    <span class="words_count_limit">
                      {{wordsTotal}}
                    </span>
                  </span>
                  <span *ngIf="isCommentMandatory==true" class="comment_mandatory">*</span>
                  <textarea [(ngModel)]="strComments" maxlength="1000" (blur)="checkRestrictedKeywords(strComments)"
                    class="cmnt_textarea" [class.invalid]="strComments=='' && isCommentMandatory"
                    (keyup)="function(strComments)">
                      </textarea>
                </div>
              </div>

              <div class="col-md-12 btn-opensearch">
                <button type="button" class="btncss me-2 btn_primary" (click)="saveData()">
                  Submit
                </button>
                <button type="button" class="btncss me-2 btn_secondary" (click)="ResetData()">
                  Clear
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>

<ng-template #restrictedKeywordModal let-modal>
  <div class="modal-content">
    <div class="modal-header model_center_header">
      <h5 class="modal-title">Keyword Replacement Chart</h5>
      <button type="button" class="close model_close_btn" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true" class="model_close_btn">×</span>
      </button>
    </div>
    <div class="modal-body custom_modal_body">
      <div class="model_content">
        <div class="table_section">
          <div class="table-responsive tablecss mt10">
            <table class="table custom_table">
              <thead>
                <tr>
                  <th>Keywords</th>
                  <th>Auto Replacement</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of restrictedKeywords">
                  <td>{{ item.restrict }}</td>
                  <td>{{ item.replace }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>